import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import {observable} from 'rxjs/symbol/observable';
const io = require('socket.io-client/dist/socket.io.js');

@Injectable()
export class SocketService {

    private socketUrl = environment.socket_url;
    private socket;
    private turnOffAlarm = true;
    public isInitialized = false;

    public init(userId) {
        this.socket = io(this.socketUrl, {path: '/socket2/socket.io/?userId='  + userId + '&'});
        this.isInitialized = true;
        // this.socket = io(this.socketUrl + '/?userId=' + userId + '&');
    }

    public onAlert(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('sosAlert', data => observer.next(JSON.parse(data)));
        });
    }

    public onAlertEBS(): Observable<any> {
        if(this.turnOffAlarm){
            return new Observable<any>(observer => {
                this.socket.on('sensorAlarm', data => observer.next(JSON.parse(data)));
            });
        }
    }

    public onAlertCPL():Observable<any> {
            return new Observable<any>(observer => {
                this.socket.on('cplinfo', data => observer.next(JSON.parse(data)));
            });
    }

    public startCare(): Observable<any> {
            return new Observable<any>(observer => {
                this.socket.on('startCare', data => observer.next(JSON.parse(data)));
            });
    }

    public stopCare(): Observable<any> {
            return new Observable<any>(observer => {
                this.socket.on('stopCare', data => observer.next(JSON.parse(data)));
            });
    }

    public startUsing(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('startUsing', data => observer.next(JSON.parse(data)));
        });
    }

    public stopUsing(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('stopUsing', data => observer.next(JSON.parse(data)));
        });
    }

    public startCharging(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('startCharge', data => observer.next(JSON.parse(data)));
        });
    }

    public onNotification(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('informationNotification', data => observer.next(JSON.parse(data)));
        });
    }

    public acceptRequest(data) {
        this.socket.emit('canceling', data);
    }

    public checkAlarms() {
        this.socket.emit('checkAlarm');
    }


    public onAccept(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('canceling', data => observer.next(JSON.parse(data)));
        });
    }

    public onStatus(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('statusOfCaregivers', data => observer.next(JSON.parse(data)));
        });
    }

    // public onUserInfo(): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.socket.on('bandsLiveData', data => observer.next(JSON.parse(data)));
    //     });
    // }

    public handleSideNotif(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('handleSideNotif', data => observer.next(JSON.parse(data)));
        });
    }

    public startHandleSideNotif(): Observable<any> {
        return new Observable<any>(observer => {
            this.socket.on('startHandleSideNotif', data => observer.next(JSON.parse(data)));
        });
    }


    public close() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    public pauseCall(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('pause-call', data => observer.next(JSON.parse(data)));
      });
    }

    public backToCall(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('back-to-call', data => observer.next(JSON.parse(data)));
      });
    }

    public careStatus(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('care-status', data => observer.next(JSON.parse(data)));
      });
    }

    public addToCall(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('add-to-call', data => observer.next(JSON.parse(data)));
      });
    }

    public guestCall(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('guest-call', data => observer.next(JSON.parse(data)));
      });
    }

    public addToQueue(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('add-to-queue', data => observer.next(JSON.parse(data)));
      });
    }

    public updateQueue(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('update-queue', data => observer.next(JSON.parse(data)));
      });
    }

    public forceCallUpdate(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('force-call-update', data => observer.next('fcu'));
      });
    }

    public refreshPage(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('refresh-page', data => observer.next('rp'));
      });
    }

    public finishedChangeImei(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('finishedChangeImei', data => observer.next(JSON.parse(data)));
      });
    }

    public snackbar(): Observable<any> {
      return new Observable<any>(observer => {
        this.socket.on('snackbar', data => observer.next(JSON.parse(data)));
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/socket.service.ts